import { render, staticRenderFns } from "./infographics-detail.vue?vue&type=template&id=69a760f5&"
import script from "./infographics-detail.vue?vue&type=script&lang=js&"
export * from "./infographics-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports